import Banner from "~/components/banner"
import HomeBanner from "./banner"
import BigTOC from "./bigToc"
import TOC from "./toc"

export default class Home extends Component {
  render() {
    const tocWidth = 380

    const chapters = [
      {
        title: "Introduction",
        sections: [
          {
            title: "Zoom In",
            published: true,
          },
          {
            title: "Circuit Designer",
            published: true,
          },
          {
            title: "Techniques",
            published: false,
          },
          {
            title: "Deep Micrographia",
            published: false,
          },
          {
            title: "Model Organisms for Interpretability",
            published: true,
          },
          {
            title: "Evaluating Claims about Features",
            published: true,
          },
        ],
      },
      {
        title: "Early Vision",
        sections: [
          { title: "Overview of Early Vision", published: false },
          { title: "Curve Detector", published: true },
          { title: "Curve Circuit", published: true },
        ],
      },
      {
        title: "Motifs",
        sections: [
          { title: "Overview of Motifs", published: false },
          { title: "The Dog Head Circuit", published: false },
        ],
      },
      {
        title: "Circuit Editing",
        sections: [
          { title: "Introduction to Circuit Editing", published: false },
          { title: "Editing an RL Agent", published: true },
        ],
      },
    ]

    return (
      <React.Fragment>
        <Surface position="sticky" gridColumn="screen">
          <Banner
            isHome
            title="Circuits"
            hasMarginBottom={false}
            subtitle="An exploration into the representations of neural networks and the interpretable circuits their connections form."
            figure={<HomeBanner />}
          />
        </Surface>
        <Surface gridColumn="screen" position="sticky" top={0} height={0}>
          <TOC width={tocWidth} chapters={chapters} />
        </Surface>
        <Surface gridColumn="screen">
          <BigTOC tocWidth={tocWidth} />
        </Surface>
      </React.Fragment>
    )
  }
}
